import type { DeploymentEnvironmentNames } from '../../constants/ppConstants';
import { DEPLOYMENT_ENVIRONMENTS } from '../../constants/ppConstants';

type EnvSpec = {
  env: DeploymentEnvironmentNames;
};

export function buildProductImageUrl(celumId: number, envSpec: EnvSpec) {
  const subdomain = getSubdomainForEnvironment(envSpec);
  return `https://${subdomain}.transgourmet.ch/shop/productimages/article/${celumId}.jpg`;
}

export function buildPromoImageUrl(celumId: number, envSpec: EnvSpec) {
  const subdomain = getSubdomainForEnvironment(envSpec);

  return `https://${subdomain}.transgourmet.ch/shop/productimages/promo/${celumId}.jpg`;
}

export function buildPictoImageUrl(pictoId: number, envSpec: EnvSpec) {
  const subdomain = getSubdomainForEnvironment(envSpec);
  return `https://${subdomain}.transgourmet.ch/shop/productimages/picto/${pictoId}.jpg`;
}

export function buildEcoScorePictoImageUrl(ecoscoreLabel: string) {
  // Ecoscore Images:
  // - Siehe: https://prodega.atlassian.net/browse/PLP-7421 und https://prodega.atlassian.net/browse/WEB-2487
  // - die Bilder aus dem Celum Export waren zu unscharf (November 2023)
  // - daher werden die SVGs im Source Code des Webshop abgelegt und diese werden als public asset mit dem Webshop deployt
  // - die aktuellen Bilder wurden direkt vom Fach (Sophie) zur Verfügung gestellt

  const ecoscoreSmallIconName = ecoscoreLabel.replace('+', '_plus').replace('-', '_minus');
  return `/assets/ecoscore/picto/Tag_color_${ecoscoreSmallIconName}.svg`;
}

function getSubdomainForEnvironment(envSpec: EnvSpec) {
  let subdomain = 'webshop';
  if (envSpec.env === DEPLOYMENT_ENVIRONMENTS.PREVIEW) {
    subdomain = 'webshoppreview';
  } else if (envSpec.env === DEPLOYMENT_ENVIRONMENTS.STAGE) {
    subdomain = 'webshopstage';
  } else if (envSpec.env === DEPLOYMENT_ENVIRONMENTS.TEST || envSpec.env === DEPLOYMENT_ENVIRONMENTS.DEVELOPMENT) {
    subdomain = 'webshoptest';
  }
  return subdomain;
}
